import React from "react";
import { Link } from "react-router-dom";
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import VersionesTabla from './VersionesTabla.jsx';

const VersionesListar = () => {
    return (
      <div>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item"><Link to="/">Administración de versiones</Link></li>
        <li className="breadcrumb-item active">Listado de usuarios y versiones</li>
      </ol>
      <h1 className="page-header">Administración de versiones <small></small></h1>
      <Panel>
        <PanelHeader>Últimas versiones</PanelHeader>
        <PanelBody>
            <VersionesTabla/>
        </PanelBody>
      </Panel>
    </div>
    );
  };
  export default VersionesListar;
